// import React, { useEffect } from 'react'
// import ContactBanner from './ContactBanner'
// import ContactForm from './ContactForm'
// // import ContactMap from './ContactMap'

// const Contactus = () => {
//        // Scroll to the top of the page when the component mounts
//        useEffect(() => {
//         window.scrollTo(0, 0);
//       }, []); // Empty dependency array ensures it only runs once when the component mounts
    
//   return (
//     <div>
//         <ContactBanner/>
//         <ContactForm/> 
//          {/* <ContactMap/> */}
//     </div>
//   )
// }

// export default Contactus;



import React, { useEffect } from "react";
import ContactBanner from "./ContactBanner";
import ContactForm from "./ContactForm";
 

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ 
      backgroundImage: "url('/image/3662a43d-artificial-intelligence.jpeg.optimal.jpeg')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundAttachment: "fixed",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh",
      width: "100%"
    }}>
      <div style={{ backgroundColor: "rgba(255, 255, 255, 0.1)",marginTop:"40px" }}> 
         <ContactBanner/>
         {/* <ContactForm/>  */}
        
      </div>
    </div>
  );
};

export default Home;